module.exports = __webpack_public_path__ + "static/media/Spain_bell_beaker_icon.99e411fc.png";